const setOffset = (state = 0, action) => {
  switch (action.type) {
    case "SETOFFSET":
      return action.payload;
    default:
      return state;
  }
};

export default setOffset;
